import { html, nothing } from 'lit';
import componentStyles from './icon-card.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import {externalLinkHoverText, isExternalUrl, leavingSiteAlertHandler, renderIcon} from '../../utils/link.js';
export default class IconCard extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * Main content area title
       */
      title: { type: String },
      /**
       * Main content area text below title
       */
      icon: { type: String },
      /**
       * Button url
       */
      bodyText: { type: String },
      /**
       * Main content area text below title
       */
      link: { type: Object },
      /**
       * Determines if the color should be inverted
       */
      invertColors: { type: Boolean },
      ignoreExternalUrl: { type: Boolean },
      ariaLabel: { type: String },
    };
  }

  firstUpdated() {
    this.externalUrl = isExternalUrl(this.link?.url)
    this.requestUpdate()
  }

  constructor() {
    super();
    this.bodyText = '';
    this.ignoreExternalUrl = true;
    this.ariaLabel = ''
  }

  getCardContent() {

    return html`
      <hf-icon name="${this.icon}" class="icon-card__icon"></hf-icon>
      <hf-heading levelStyle="heading4" class="icon-card__title" aria-level=”2”>
        ${this.title}
      </hf-heading>
      ${this.bodyText.length
        ? html`
            <div class="icon-card__body-text">
              <hf-wysiwyg markup="${this.bodyText}"></hf-wysiwyg>
            </div>
          `
        : nothing}
      ${this.link
        ? html`
            <a
              @click="${this.onClick}"
              href="${this.link?.url}"
              target=${ifDefined(this.link.target ? this.link.target : undefined)}
              title="${isExternalUrl(this.link?.url) ? externalLinkHoverText() : this.link?.text}"
              class="${classMap({
                'icon-card__anchor': true,
                'icon-card--external': this.externalUrl,
              })}"
              aria-label=${ifDefined(this.arialabel ? this.arialabel : undefined)}
            >
              <div class="icon-card__link">
                ${this.link?.text !== this.link?.url
                  ? html`
                    <span class="icon-card__link-text">
                      ${this.link?.text}
                    </span>
                    ${renderIcon(this.href, this.ignoreExternalUrl)}`
                  : nothing}
                  <span class="icon-card__link-icon"
                    ><hf-icon name="arrow-right" class="btn__icon"></hf-icon>
                  </span>
              </div>
            </a>
          `
        : nothing}`;
  }

  onClick(event) {
    if (this.externalUrl && !leavingSiteAlertHandler()) {
      event.preventDefault()
    }

    if (this.link.gtm) {
      dataLayer.push({
        'event': this.link.gtm,
      });
      console.log("GTM triggered :" + this.link.gtm);
    }
  }

  render() {
    return html`
      <div
        class="${classMap({
          'icon-card': true,
          'icon-card--default': this.url,
          'icon-card--steps': !this.url,
          'icon-card--inverted-colors': this.invertColors,
        })}">
        <div class="icon-card__wrapper">
          ${this.getCardContent()}
        </div>
      </div>
    `;
  }
}

customElements.define('hf-icon-card', IconCard);
